export function logInTracking() {
  // localStorage.setItem("userIsLoggedIn", 1)
  window.dataLayer.push({
    event: 'login',
    page: window.location.href,
    box_user_id: document.querySelector("[property~=user-id][content]")?.content ?? 0,
    login_case: localStorage.getItem('login_case')
  });
}

export function logOutTracking() {
  window.dataLayer.push({
    event: 'logout',
    page: window.location.href,
    box_user_id: document.querySelector("[property~=user-id][content]")?.content ?? 0,
    login_case: '-',
  });
}
